import { render, staticRenderFns } from "./supply_review.vue?vue&type=template&id=722a9b1c&scoped=true"
import script from "./supply_review.vue?vue&type=script&lang=ts"
export * from "./supply_review.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722a9b1c",
  null
  
)

export default component.exports